
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";

  @Component({})
  export default class AppThCell extends Vue {
    @Prop() cell: IAppTable.ITableProp;
    @Prop() sortingData!: IAppTable.ISortingData;

    sortDirection = IApp.SortDirection;

    get disableSorting() {
      return !this.sortingData
        || this.cell.propType === IApp.SortingPropType.Actions
        || this.cell.noSorting
        ;
    }

    setSorting() {
      if (this.disableSorting) return;
      this.$emit('setSorting', this.cell);
    }
  }
